import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="main-navbar-container">
      <nav className="navbar" aria-label="Primary navigation">
        <div className="navbar-logo">
          <Link to="/" aria-label="CRYPTOXNFT home">
            <img src="/assets/images/logo.jpg" alt="Logo" />
            <span>CRYPTOXNFT</span>
          </Link>
        </div>
        <button
          type="button"
          className={`menu-icon ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isOpen}
          aria-controls="primary-navigation"
        >
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </button>
        <ul className={`navbar-links ${isOpen ? "active" : ""}`} id="primary-navigation">
          <li>
            <NavLink to="/" onClick={closeMenu}>
              Home
            </NavLink>
          </li>
          <li className="dropdown">
            <NavLink to="/services" onClick={closeMenu}>
              Services
            </NavLink>
          </li>
          <li>
            <NavLink to="/partners" onClick={closeMenu}>
              Exchanges
            </NavLink>
          </li>
          <li>
            <NavLink to="/results" onClick={closeMenu}>
              Results
            </NavLink>
          </li>
        </ul>
        <a
          className="telegram-button"
          href="https://t.me/cryptoxnfts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Free Telegram</span>
          <img src="/assets/icons/tgWhite.png" alt="" aria-hidden="true" />
        </a>
      </nav>
    </div>
  );
}

export default Navbar;
